export default "__VITE_ASSET__bW0G1BYl__"